export function configurePwaThemeAssets() {
  const preference = window.matchMedia("(prefers-color-scheme: dark)");
  const update = () => {
    const dark = preference.matches;
    const manifest = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    const appleIcon = document.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]');
    if (manifest) manifest.href = dark ? "/manifest-dark.webmanifest" : "/manifest-light.webmanifest";
    if (appleIcon) appleIcon.href = dark ? "/icons/apple-touch-icon-dark.png" : "/icons/apple-touch-icon.png";
  };
  update();
  preference.addEventListener("change", update);
  return () => preference.removeEventListener("change", update);
}
